import { Modal } from 'antd';
import NiceModal from '@ebay/nice-modal-react';
import { DownloadOrderModal } from './DownloadOrderModal';

export const DownloadPaperModal = NiceModal.create(
    ({ orderNo, fallbackOrderNo, queryType = 'query', queryPath, afterClose }) => {
        const modal = NiceModal.useModal();
        return (
            <Modal
                title="生成结果与文件下载"
                zIndex={1910}
                open={modal.visible}
                onCancel={() => modal.hide()}
                afterClose={afterClose}
                footer={null}
                destroyOnClose
                width={680}
            >
                <DownloadOrderModal
                    key={`${queryPath || queryType}:${orderNo}`}
                    orderNo={orderNo}
                    fallbackOrderNo={fallbackOrderNo}
                    queryType={queryType}
                    queryPath={queryPath}
                />
            </Modal>
        );
    },
);
